/**
 * useProfileUtils — Utility functions for profile data transformation.
 */
import { useCallback } from 'react';
import { formatUserId } from '@/lib/profiles';
import { ProfilesState } from './useProfilesState';

export function useProfileUtils(
  state: ProfilesState,
  refetchUserProfiles: (idsToRefetch: string[]) => Promise<void>
) {
  const { profiles } = state;

  const getDisplayName = useCallback((userId: string): string => {
    if (!userId) return 'Unknown User';
    
    const profile = profiles[userId];
    
    if (profile?.display_name) return profile.display_name;
    if (profile?.email) return profile.email.split('@')[0];
    
    if (!profile) {
      refetchUserProfiles([userId]);
      return formatUserId(userId);
    }
    
    return formatUserId(userId);
  }, [profiles, refetchUserProfiles]);

  return {
    getDisplayName
  };
}
